<template>
    <div>
        <base-input
            v-model="form.name"
            validate="required"
            label="Name"
            name="name"/>

        <base-text-area
            name="description"
            label="Description"
            v-model="form.description"/>

        <base-button
            :loading="loading"
            @click="submit"
            class="is-primary"
            icon="fas fa-check"
            text="Save"/>&nbsp;

        <base-button
            @click="$emit('cancel')"
            class="is-danger"
            icon="fas fa-times"
            text="Cancel"/>
    </div>
</template>

<script>
import { copy } from '../../utils/helpers';

export default {
    name: 'MilestoneForm',
    props: {
        loading: { type: Boolean },
        init_data: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            form: { name: '', description: '', ...this.init_data },
        };
    },
    methods: {
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$emit('submit', copy(this.form));
                this.form = { name: '', description: '' };
            });
        },
    },
};
</script>
